import { render } from "./post-smtp-img.vue?vue&type=template&id=54d8f47a"
import script from "./post-smtp-img.vue?vue&type=script&lang=js"
export * from "./post-smtp-img.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__